/**
 * 代码生成功能用常数
 *
 * @author Jay Qing
 */

/**
 * 操作类型
 */
export const ACTIONS = {

  /**
   * 查询
   */
  QUERY: 'query',
  /**
   * 查询
   */
  TABLE: 'table',
  /**
   * 新增
   */
  CREATE: 'create',
  /**
   * 删除
   */
  DELETE: 'delete',
  /**
   * 修改
   */
  UPDATE: 'update',
  /**
   * 导入
   */
  IMPORT: 'import',
  /**
   * 导出
   */
  EXPORT: 'export'

}

/**
 * UI组件
 */
export const UI_COMPONENTS = {
  /**
   * 输入框
   */
  INPUT: { name: 'input', represent: 'FORM_ITEM.INPUT' },
  /**
   *输入框-整数
   */
  INPUT_INTEGER: { name: 'input-integer', represent: 'FORM_ITEM.INPUT_NUMBER' },
  /**
   * 输入框-小数
   */
  INPUT_DECIMAL: { name: 'input-decimal', represent: 'FORM_ITEM.INPUT_NUMBER' },
  /**
   * 下拉选择框
   */
  SELECT: { name: 'select', represent: 'FORM_ITEM.SELECT' },
  /**
   *选择框-日期
   */
  SELECT_DATE: { name: 'select-date', represent: 'FORM_ITEM.DATE_PICKER' },
  /**
   *选择框-时间
   */
  SELECT_TIME: { name: 'select-time', represent: 'FORM_ITEM.TIME_PICKER' },
  /**
   *选择框-日期时间
   */
  SELECT_DATETIME: { name: 'select-datetime', represent: 'FORM_ITEM.DATETIME_PICKER' }

}

/**
 * 下拉选择框选项
 */
export const SELECT_OPTIONS = {

  /**
   * 属性类型
   */
  PROP_TYPE: [
    {
      label: 'Byte',
      value: 'Byte'
    },
    {
      label: 'Short',
      value: 'Short'
    },
    {
      label: 'Char',
      value: 'Char'
    },
    {
      label: 'Integer',
      value: 'Integer'
    },
    {
      label: 'Long',
      value: 'Long'
    },
    {
      label: 'Float',
      value: 'Float'
    },
    {
      label: 'Double',
      value: 'Double'
    },
    {
      label: 'BigInteger',
      value: 'BigInteger'
    },
    {
      label: 'BigDecimal',
      value: 'BigDecimal'
    },
    {
      label: 'String',
      value: 'String'
    },
    {
      label: 'Boolean',
      value: 'Boolean'
    },
    {
      label: 'Date',
      value: 'Date'
    },
    {
      label: 'LocalDate',
      value: 'LocalDate'
    },
    {
      label: 'LocalTime',
      value: 'LocalTime'
    },
    {
      label: 'LocalDateTime',
      value: 'LocalDateTime'
    }
  ],

  /**
   * UI组件
   */
  UI_COMPONENT: [{
    label: '输入框',
    value: 'input'
  }, {
    label: '输入框-整数',
    value: 'input-integer'
  }, {
    label: '输入框-小数',
    value: 'input-decimal'
  },
  {
    label: '下拉选择框',
    value: 'select'
  },
  {
    label: '选择框-日期',
    value: 'select-date'
  },
  {
    label: '选择框-时间',
    value: 'select-time'
  },
  {
    label: '选择框-日期时间',
    value: 'select-datetime'
  }],

  /**
   * 匹配方式
   */
  MATCH_METHOD: [{
    label: '>',
    value: 'greater_than'
  }, {
    label: '<',
    value: 'less_than'
  }, {
    label: '=',
    value: 'equal'
  }, {
    label: '>=',
    value: 'greater_or_equal'
  }, {
    label: '<=',
    value: 'less_or_equal'
  }, {
    label: '!=',
    value: 'not_equal'
  }, {
    label: 'LIKE %',
    value: 'like_right'
  }, {
    label: '% LIKE',
    value: 'like_left'
  }, {
    label: '% LIKE %',
    value: 'like_full'
  }]
}

export function getComponentByName(name: string) {
  for (const comp of Object.values(UI_COMPONENTS)) {
    if (comp.name === name) {
      return comp
    }
  }
}

/**
 * 公共字段
 */
export const COMMON_COLUMNS = ['id', 'created_by', 'created_at', 'updated_by', 'updated_at']

